import React from "react";

import Mountains from "./Moutains";
import Rocket from "./Flight";

import Mission from "../../../images/mission-touch.png";
import Values from "../../../images/values.png";
import WhatisDtak from "../../../images/what-is-dtak.svg";
import History from "../../../images/history.png";



import "./cssonly.css";

function CssOnly() {
  return (
    <div>
      <div className="img3">
        <div className="ptext">
          <span className="border2"> What is DTAK?</span>
        </div>
        <div style={{ height: "300px", overflow: "hidden" }}>
          <Mountains />
        </div>
      </div>

      <section className="section section-light">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-xs-12 col-md-6 text-center">
            <img
              src={WhatisDtak}
              alt="logo"
              className="img-fluid what-is-dtak"
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <p className="text-light-gold">
              The Decentralized Team Awareness Kit (DTAK) is an innovative
              mobile application designed for secure, Decentralized
              communication and collaboration. By leveraging cutting-edge
              technology, it empowers individuals and organizations to connect
              and collaborate safely and privately, free from the limitations of
              traditional centralized systems.
            </p>
          </div>
        </div>
      </section>

      <div className="img3">
        <div className="ptext">
          <span className="border-gradient"> Our Mission</span>
        </div>
        {/* <div style={{ height: "300px", overflow: "hidden" }}>
          <Rocket />
        </div> */}
      </div>

      <section className="section section-light">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-xs-12 col-md-6">
            <p>
              At DTAK, our mission is to deliver secure, Decentralized
              communication and collaboration solutions that empower users by
              prioritizing privacy and trust. We are dedicated to continuous
              innovation, enhancing how people connect and collaborate
              effectively.
            </p>
          </div>
          <div className="col-xs-12 col-md-6 text-center">
            <img
              src={Mission}
              class="img-fluid align-self-center"
              // height={} width={}
              alt="logo"
            />
          </div>
        </div>
      </section>

      <div className="img3">
        <div className="ptext">
          <span className="border-gradient"> Core Values </span>
        </div>
      </div>

      <section className="section section-light">
        <div className="row d-flex justify-content-center align-items-center ">
          <div className="col-xs-12 col-md-6 text-center">
            <img src={Values} class="img-fluid align-self-center" alt="logo" />
          </div>
          <div className="col-xs-12 col-md-6">
            <p className="mb-2 ">
              <b>Privacy</b>: Control over personal data.
            </p>
            <p className="mb-2">
              <b>Security</b>: Robust protection for communications.
            </p>
            <p className="mb-2">
              <b>Innovation</b>: Continuous advancement in technology.
            </p>
            <p>
              <b>User Empowerment</b>: Tools for confident collaboration.
            </p>
          </div>
        </div>
      </section>

      <div className="img3">
        <div className="ptext">
          <span className="border-gradient"> History </span>
        </div>
      </div>

      <section className="section section-light">
      
        <div className="row d-flex justify-content-center align-items-center ">
          <div className="col-xs-12 col-md-6 text-center">
            <img src={History} class="img-fluid align-self-center rounded rounded-3" height={300} width={300} alt="logo" />
          </div>
          <div className="col-xs-12 col-md-6">
          <p>
              <b>DTAK</b> originated from <b>CivTAK,</b> a platform initially
              designed for secure communication in civic contexts. Recognizing
              the growing demand for Decentralized solutions, CivTAK evolved
              into DTAK, broadening its focus to deliver secure, private
              communication and collaboration tools for both individuals and
              organizations. This transition reflects our commitment to
              continuous innovation and user empowerment in an increasingly
              digital world.
            </p>
          </div>
        </div>
          <div className="col-xs-12 text-center">
            
          </div>
    
      </section>

      <div className="img3">
        <div className="ptext">
          <span className="border-gradient"> Key Features </span>
        </div>
      </div>
    </div>
  );
}

export default CssOnly;
